import { useContext } from 'react';
import { FilterOption } from '@commerce-payment-webcomponents/sdk';
import { Skeleton } from '../../../common/skeleton/Skeleton';
import FilterOptionContext from '../../../../common/FilterOptionContext';
import styles from './PaymentMethodLoader.module.scss';

export const PaymentMethodLoader = () => {
  const filterOption: FilterOption | undefined = useContext(FilterOptionContext);

  return (
    <div className={styles['paymentMethod-loader-container']} data-testid={'paymentMethod-loader-container'}>
      {/* <!--Internal option loader--> */}
      {!filterOption?.retry && (
        <>
          <div className={styles['paymentMethod-loader-container-internal-payment']}>
            <div className={styles['header']}>
              <div className={styles['label-container']}>
                <div className={styles['label']}>
                  <Skeleton height="42" borderRadius="8" />
                </div>
              </div>
              <div className={styles[`toggle-container`]}>
                <Skeleton height="24" borderRadius="14" width="48" />
              </div>
            </div>
          </div>
          <div className={styles['paymentMethod-loader-container-remaining-payment']}>
            <Skeleton height="36" borderRadius="8" />
          </div>
        </>
      )}
      <div className={styles['paymentMethod-loader-container-external-payment']}>
        {[1, 2, 3, 4].map((key) => (
          <div key={key} className={styles['option-wrapper']}>
            <Skeleton borderRadius="8" height="24" width="25" />
            <div className={styles['label-wrapper']}>
              <Skeleton borderRadius="8" height="24" />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
